import { tableColumnsType } from '../components/edit-table/editable-table';

const allRfqMasterColumns: tableColumnsType[] = [
  {
    Header: 'RFQ Code',
    accessor: 'rfqcode',
    editType: 'inputField',
  },

  {
    Header: 'Submission Date',
    accessor: 'submissiondate',
    editType: 'inputField',
  },
  {
    Header: 'Status Code',
    accessor: 'status',
    editType: 'inputField',
  },
  {
    Header: 'Status',
    accessor: 'statusDescription',
    editType: 'inputField',
  },
  {
    Header: 'Contents',
    accessor: 'content',
    editType: 'inputField',
  },
  {
    Header: 'Requested by',
    accessor: 'requestedBy',
    editType: 'inputField',
  },
];

export default allRfqMasterColumns;
